import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange } from '@angular/core';

export interface IDDFormNameData {
  name: string;
  data: any;
}


export interface IAppFormDropdowParameters {
  choices: IDDFormNameData[];
  selectedIndex: number;
  input_title: string;
  title: string;
  hasButton: boolean;
  button_title: string;
  help: string;
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-form-dropdown',
  templateUrl: './app-form-dropdown.component.html',
  styleUrls: ['./app-form-dropdown.component.scss']

})
export class AppFormDropdownComponent implements OnInit, OnChanges {
  @Input() parameters: IAppFormDropdowParameters ;
  @Output() onSelect = new EventEmitter();
  @Output() onClick = new EventEmitter();

  index = 0;

  get selected(): string {
    if (this.index < this.parameters.choices.length) {
      return this.parameters.choices[this.index].name;
    } else {
      return '';
    }
  }

  get hasData(): boolean {
    if (this.parameters) {
      return true;
    } else {
      return false;
    }
  }

  ngOnInit() {
    if (this.parameters) {
      this.index = this.parameters.selectedIndex;
    }
  }

  ngOnChanges(changeMap) {
    if ('parameters' in changeMap) {
      const change: SimpleChange = changeMap.parameters;

      if (change.currentValue) {
        this.index = this.parameters.selectedIndex;
      }
    }
  }

  onSelected(nameValue: IDDFormNameData) {

    this.index = this.parameters.choices.indexOf(nameValue);
    this.onSelect.emit(nameValue);
  }

  onClicked() {
    this.onClick.emit(this.parameters.choices[this.index]);
  }
}
